function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P5Main = function P5Main(_ref) {
  var page = _ref.page;
  var thisPage = 7;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $('.p5-grey').addClass('p5-grey__active');
      }, 1500), setTimeout(function () {
        $('.p5-know').addClass('p5-know__active');
      }, 1500), setTimeout(function () {
        $('.p5-bg').addClass('p5-bg__active');
      }, 3000), setTimeout(function () {
        $('.p5-90').addClass('p5-90__active');
      }, 3000), setTimeout(function () {
        $('.p5-main-m').addClass('p5-main-m__active');
      }, 1500)]);
    } else {
      $('.p5-grey').removeClass('p5-grey__active');
      $('.p5-know').removeClass('p5-know__active');
      $('.p5-bg').removeClass('p5-bg__active');
      $('.p5-90').removeClass('p5-90__active');
      $('.p5-main-m').removeClass('p5-main-m__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p5-main"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p5/did-you-know-bg@3x.png",
    className: "p5-grey"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p5/did-you-know@3x.png",
    className: "p5-know"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p5/did-you-know-answer-bg@3x.png",
    className: "p5-bg"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p5/landfilled-construction-waste-is-reusable@3x.png",
    className: "p5-90"
  })), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p5/mobile-did-you-know@2x.png",
    className: "p5-main-m"
  }));
};
export default P5Main;